/**
 * @module features/clients/components/ClientDataTable
 * @description Alias and re-export for ClientTable to preserve backward compatibility.
 */
export { ClientTable as ClientDataTable } from "./ClientTable";
export type { ClientTableProps as ClientDataTableProps } from "./ClientTable";
